var _line, _line2, _circle, _path, _circle2, _path2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoBrandStepReservationDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 718,
    height: 34,
    viewBox: "0 0 718 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 338,
    y1: 16.5,
    x2: 43,
    y2: 16.5,
    stroke: "#545454"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 688,
    y1: 16.5,
    x2: 393,
    y2: 16.5,
    stroke: "#545454"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#A4861E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 13L16.2 22L11 17.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 17,
    r: 17,
    fill: "#A4861E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M372 13L365.2 22L360 17.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 708,
    cy: 16,
    r: 10,
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBrandStepReservationDetails);
export default __webpack_public_path__ + "static/media/noBrandStepReservationDetails.552e2e50261c9fce5eaea91ce518f281.svg";
export { ForwardRef as ReactComponent };